// @ts-strict-ignore
import {EntryRowTypeHelpers} from 'common/query-builder/query-entry-section/row-types/types';
import {FlowsQueryEventEntry, SelectorTypeDefinitions} from 'common/query-builder/query-entry-section/types';
import {currentProjectStore} from 'common/report/stores/project-details';
import {ProjectFeatureFlag} from 'common/report/constants';
// eslint-disable-next-line import/no-cycle
import {helpers as SuperEntryRowHelpers} from 'common/query-builder/query-entry-section/row-types/super-entry/helpers';

// eslint-disable-next-line import/no-cycle
import {FlowsEntryRow} from './index';
import {hasEventValue, OVERRIDE_STARTING_FORWARD_VALUE, STARTING_FORWARD_VALUE} from './utils';

export const helpers: EntryRowTypeHelpers<FlowsQueryEventEntry> = {
  component: FlowsEntryRow,
  getNewEntry: () => ({
    type: SelectorTypeDefinitions.FlowsEvent,
    event: {
      custom: false,
      id: null,
      label: ``,
      value: null,
    },
    forward: currentProjectStore.value?.hasFeatureFlag(ProjectFeatureFlag.FlowsLessDefaultSteps)
      ? OVERRIDE_STARTING_FORWARD_VALUE
      : STARTING_FORWARD_VALUE,
    filters: [],
  }),
  isPlaceholder(row) {
    return SuperEntryRowHelpers.isPlaceholder(row);
  },
  isIntermediatePlaceholder(row) {
    return this.isPlaceholder(row) && hasEventValue(row.entry);
  },
};
